import { IStoreDocument } from '../store/IStoreDocument';
import { IEvent } from './IEvent';

export interface IEventDocument extends IEvent, IStoreDocument {
}